export default "__VITE_ASSET__DMrZdiP0__$_?nuxt_component=async&nuxt_component_name=IconFrameShapeCateye&nuxt_component_export=default__"